import React from 'react';
import { FormLabel } from '@mui/material';
import { useFormikContext } from 'formik';
import { UserRoleSelect } from '@/components/views/SettingsView/BrokerageUsersTable/UserRoleSelect';

export const RoleField = ({ canEdit }) => {
	const { values, setFieldValue } = useFormikContext();

	return (
		<>
			<FormLabel>Role</FormLabel>
			<UserRoleSelect
				fullWidth
				size='medium'
				value={values.role ?? ''}
				disabled={!canEdit}
				includeAllOption={false}
				onChange={(event) => setFieldValue('role', event.target.value)}
			/>
		</>
	);
};

export default RoleField;
